import { styled, css } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const Styled = {
  Container: styled(Box)<{ height?: number }>`
    ${({ theme, height }) => css`
      border-radius: ${theme.spacing(1)};
      margin-right: ${theme.spacing(2)};
      background-color: ${theme.palette.grey[800]};
      '& img': {
        height: ${height} px;
      }
    `}
    overflow: hidden;
    position: relative;
  `,
};
